import { Control, ControlsTreeContext } from "@/types/controls";
import { ClipboardData } from "@/types/copy-paste";
import { fpJsonStringify } from "@/util/fp-json-stringify";
import { fold } from "fp-ts/lib/Either";
import { pipe } from "fp-ts/lib/function";
import { getDataFromClipboard, writeToClipboard } from "./copy-paste";
import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";
import { getHash } from "@/util/hash";

export async function copyControlSectionPropertiesData(
  path: string,
  control: Control,
  context: ControlsTreeContext
) {
  const dataToStoreOnClipboard: ClipboardData = {
    controlSectionPropertiesData: {
      controlSectionShapeHash: getShapeHash(path, control),
      propertiesData: {
        propertiesData: context.getControlValue(path)
      }
    }
  };

  pipe(
    dataToStoreOnClipboard,
    fpJsonStringify,
    fold(
      e => console.error("Failed to copy", ...e.map(err => err.toString())),
      async jsonToStoreOnClipboard => {
        await writeToClipboard(jsonToStoreOnClipboard);
      }
    )
  );
}

export async function canPasteControlSectionPropertiesData(
  path: string,
  control: Control
) {
  const clipboardData = (await getDataFromClipboard())
    ?.controlSectionPropertiesData;

  if (!clipboardData) return false;

  if (clipboardData.controlSectionShapeHash !== getShapeHash(path, control))
    return false;

  return true;
}

export async function pasteControlSectionPropertiesData(
  path: string,
  control: Control,
  context: ControlsTreeContext
) {
  const clipboardData = (await getDataFromClipboard())
    ?.controlSectionPropertiesData;

  if (!clipboardData) return;

  if (clipboardData.controlSectionShapeHash !== getShapeHash(path, control))
    return;

  context.setControlValue(
    path,
    clipboardData.propertiesData.propertiesData,
    control
  );
}

function getShapeHash(path: string, control: Control): string {
  const controlAsJson = jsonStringifyOrUndefined(control);
  if (!controlAsJson) {
    throw "couldn't jsonStringifyOrUndefined on control";
  }

  return getHash(`${path} ${controlAsJson}`);
}
